import TableButton from './TableButton';

export default function TableButtons({ buttons }) {
  if (buttons.length === 0) return null;
  return buttons.map((button) => (
    <TableButton key={button.label} button={button} />
  ));
}
